<template>
  <div class="herramientas-frp">
    <div v-if="utilidadActiva === null">
      <div class="herramientas-head">
        <div>
          <h2 class="herramientas-titulo">Herramientas</h2>
          <p class="herramientas-subtitulo">
            Utilidades de procesamiento de datos para el equipo FRP.
          </p>
        </div>
        <span class="herramientas-badge">
          <i class="material-icons">admin_panel_settings</i>
          Solo admin
        </span>
      </div>

      <div class="herramientas-grid">
        <div
          v-for="utilidad in utilidades"
          :key="utilidad.id"
          class="herramienta-card"
          @click="abrirUtilidad(utilidad)"
        >
          <div class="herramienta-card-icon">
            <i class="material-icons">{{ utilidad.icono }}</i>
          </div>
          <h3>{{ utilidad.titulo }}</h3>
          <p>{{ utilidad.descripcion }}</p>
          <span class="herramienta-card-cta">
            Abrir
            <i class="material-icons">arrow_forward</i>
          </span>
        </div>

        <div class="herramienta-card herramienta-card--disabled">
          <div class="herramienta-card-icon">
            <i class="material-icons">hourglass_empty</i>
          </div>
          <h3>Próximamente</h3>
          <p>
            Este espacio está pensado para crecer — cada utilidad nueva
            aparece aquí como una tarjeta más.
          </p>
          <span class="herramienta-card-cta">Aún no disponible</span>
        </div>
      </div>
    </div>

    <div v-else>
      <a href="#" class="herramientas-volver" @click.prevent="cerrarUtilidad">
        ‹ Herramientas
      </a>
      <component :is="utilidad(utilidadActiva).componente"></component>
    </div>
  </div>
</template>

<script>
import PromediosForma from "@/components/frpm/components/herramientas/promedios-forma/PromediosForma.vue";

export default {
  data() {
    return {
      utilidades: [
        {
          id: "promedios-forma",
          nombre:
            "Promedios de puntuaciones transformadas por Forma con rangos de color",
          titulo: "Promedios por Forma",
          descripcion:
            "Sube un Excel con puntuaciones transformadas (Forma A/B) y descarga los promedios por Grupo/SubGrupo, coloreados por rango de riesgo.",
          icono: "table_chart",
          componente: "PromediosForma",
        },
      ],
      utilidadActiva: null,
    };
  },
  props: {
    frsm: Object,
    process: Object,
    tokenUser: Object,
  },
  methods: {
    abrirUtilidad(utilidad) {
      this.utilidadActiva = utilidad.id;
    },
    cerrarUtilidad() {
      this.utilidadActiva = null;
    },
    utilidad(id) {
      return this.utilidades.find((u) => u.id === id) || {};
    },
  },
  components: {
    PromediosForma,
  },
};
</script>

<style lang="scss" scoped>
.herramientas-frp {
  padding: 20px 24px;
}

.herramientas-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 20px;
}

.herramientas-titulo {
  font-size: 19px;
  font-weight: 700;
  margin: 0 0 4px;
}

.herramientas-subtitulo {
  margin: 0;
  color: #7a7a7a;
  font-size: 13px;
}

.herramientas-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #522687;
  background: #efe7f7;
  padding: 4px 10px;
  border-radius: 999px;
  white-space: nowrap;
}

.herramientas-badge .material-icons {
  font-size: 14px;
}

.herramientas-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
  margin-bottom: 8px;
}

.herramienta-card {
  border: 1px solid #dbdbdb;
  border-radius: 8px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.herramienta-card:hover {
  border-color: #522687;
  box-shadow: 0 0 0 1px #522687;
}

.herramienta-card-icon {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: #efe7f7;
  color: #522687;
  display: flex;
  align-items: center;
  justify-content: center;
}

.herramienta-card h3 {
  font-size: 14.5px;
  font-weight: 700;
  margin: 0;
}

.herramienta-card p {
  margin: 0;
  color: #7a7a7a;
  font-size: 12.5px;
  line-height: 1.5;
}

.herramienta-card-cta {
  margin-top: 4px;
  font-size: 12.5px;
  font-weight: 600;
  color: #522687;
  display: flex;
  align-items: center;
  gap: 4px;
}

.herramienta-card-cta .material-icons {
  font-size: 15px;
}

.herramienta-card--disabled {
  cursor: default;
  opacity: 0.55;
  pointer-events: none;
}

.herramienta-card--disabled .herramienta-card-cta {
  color: #7a7a7a;
}

.herramientas-volver {
  display: inline-block;
  margin-bottom: 15px;
  color: #522687;
  font-size: 12.5px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/Herramientas.vue